<div class="width-hack"
     [class.never-hide]="neverHide">
</div>
<div *ngIf="isMenuVisibleOnSmallScreen"
     class="menu-toggler-background"
     (click)="onToggleMenuClicked($event)">
</div>
<button mat-mini-fab
        class="menu-toggler"
        [class.never-hide]="neverHide"
        color="default"
        (click)="onToggleMenuClicked($event)">
    <mat-icon *ngIf="!isMenuVisibleOnSmallScreen" color="accent">menu</mat-icon>
    <mat-icon *ngIf="isMenuVisibleOnSmallScreen" color="accent">close</mat-icon>
</button>
<div class="wrapper mat-elevation-z2"
     style="z-index: 999;"
     [class.small-screen-hider]="!isMenuVisibleOnSmallScreen"
     [class.never-hide]="neverHide">
    <div class="top">
        <img class="logo"
             [src]="conf.assetsUrl + 'img/header-logo.png'"
             [routerLink]="'/'"  alt="logo"/>
    </div>
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
